import styles from './item-grid.module.scss';

export interface ItemGridProps {
  children: JSX.Element[];
}

const ItemGrid = ({ children }: ItemGridProps) => {
  const renderItems = children.map(item => (
    <div key={item.key} className={styles.item}>
      {item}
    </div>
  ));

  return <div className={styles.component}>{renderItems}</div>;
};

ItemGrid.displayName = 'ItemGrid';

export default ItemGrid;
